/* eslint-disable import/no-anonymous-default-export */
import floor from 'lodash/floor'
import split from 'lodash/split'
import toString from 'lodash/toString'
import some from 'lodash/some'
import isUndefined from 'lodash/isUndefined'

// Addons 2024-05-19
const host_divk = process.env.REACT_APP_DIVISION_K || ''

export default ({
  divisionlogin='E',
  productPrice= 0,
  discountPrice= 0,
  packingSize= 0,
  qty=0,
  qtyp=0,
  vatcode= 'Y',
  customerCode= '',
  customser_whiteList
}) => {
  console.log(`2024-05-19 :: calculateFinalOrderPrice.js ==> divisionlogin ==> `,divisionlogin)
  console.log(`2024-05-19 :: calculateFinalOrderPrice.js ==> host_divk ==> `,host_divk)

  let checkDecimal = split(toString(productPrice), '.')
  let quantity = (parseFloat(qty) * parseFloat(packingSize)) + parseFloat(qtyp)
  let price = parseFloat(productPrice) / parseFloat(packingSize) 
  let discount = parseFloat(discountPrice) / parseFloat(packingSize)

  let finalPrice = 0.00
  if(divisionlogin === host_divk){
    console.log(`2024-05-19 :: finalPrice in case div.K`)
    finalPrice = (price - discount) * quantity
    finalPrice = Math.round(10000 * parseFloat(finalPrice))/10000
  }else{
    console.log(`2024-05-19 :: finalPrice in case div.E`)
    finalPrice = (price - discount) * parseFloat(quantity) 
  }

  let finalPriceCheck = finalPrice

  finalPrice = parseFloat(checkDecimal[1]) > 0 ? floor(finalPrice, 4) : finalPrice
  finalPrice = Math.floor(100 * finalPrice) / 100

  if (some(customser_whiteList, { customer_code: customerCode })) {
    //Create new bill for 01287459
    finalPrice = (price - discount) * parseFloat(quantity)
    finalPrice = parseFloat(finalPrice).toFixed(2)
  }

  if (parseFloat(discountPrice) <= 0) {
    //finalPrice.toFixed(2)
    parseFloat(finalPrice).toFixed(2)
  } else {
    let finalSpit = split(toString(finalPriceCheck), '.')
    if (!isUndefined(finalSpit[1])) {
      let decimalPrevious = toString(finalSpit[1]).substring(1, 2)
      let decimaFinalCheck = toString(finalSpit[1]).substring(2, 4)
      if (decimaFinalCheck === '99' && parseFloat(decimalPrevious) <= 4) finalPrice = finalPrice + 0.01
    }

    let finalCheck = split(toString(finalPrice), '.')
    finalPrice = (parseFloat(finalCheck[1]) < 99 || isUndefined(finalCheck[1])) ?  parseFloat(finalPrice).toFixed(2) : parseFloat(finalCheck[0]) + 1
  }

  let noDiscPrice = 0.00
  if(divisionlogin === host_divk){
    console.log(`2024-05-19 :: noDiscPrice in case div.K`)
    noDiscPrice = parseFloat(productPrice) / parseFloat(packingSize)
    noDiscPrice = noDiscPrice * quantity
    noDiscPrice = Math.round(10000 * parseFloat(noDiscPrice))/10000
  }else{
    console.log(`2024-05-19 :: noDiscPrice in case div.E`)
    noDiscPrice = (parseFloat(productPrice) / parseFloat(packingSize))  * parseFloat(quantity)
  }

  let finalNetPrice = vatcode === 'Y' ? parseFloat(finalPrice) + (parseFloat(finalPrice) * 0.07) : parseFloat(finalPrice) * 1

  noDiscPrice = floor(noDiscPrice, 4)
  noDiscPrice = Math.floor(100 * noDiscPrice) / 100
  noDiscPrice = noDiscPrice.toFixed(2)

  if (some(customser_whiteList, { customer_code: customerCode })) {
    //Create new bill for 01287459
    noDiscPrice = finalPrice
  }

  let vat = vatcode === 'Y' ? parseFloat(finalPrice) * 0.07 : 0

  return {
    price: parseFloat(finalPrice),
    netPrice: parseFloat(finalNetPrice.toFixed(2)),
    noDiscPrice: parseFloat(noDiscPrice),
    vat: parseFloat(vat.toFixed(2))
  }
}